import React from "react";
import PropTypes from "prop-types";
import { Tag } from "@src/components/atoms";
import AppUtils from "@src/utils/appUtils";
import { useDCContext } from "@src/context/dcContext";

const AdditionalFilterTagTray = (props) => {
  const { additionalFilters, closeFunc, isAviation } = props;
  const dcContext = useDCContext();
  const { getDynamicReplacement } = dcContext;

  //dynamic content
  const tagTrayText = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__additional_filter_tray_text",
  );
  const behaviourFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__behaviour_filter__menu_title",
    {},
    "",
    true,
  );
  const behaviourFilterSuccessOption = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__behaviour_filter__success_option",
    {},
    "",
    true,
  );
  const behaviourFilterFailOption = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__behaviour_filter__fail_option",
    {},
    "All",
    true,
  );
  const originFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__origin_filter__menu_title",
    {},
    "",
    true,
  );
  const destinationFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__destination_filter__menu_title",
    {},
    "",
    true,
  );
  const voyageFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__voyage_filter__menu_title",
    {},
    "",
    true,
  );
  const vehicleFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__vehicle_filter__menu_title",
    {},
    "",
    true,
  );
  const vehicleFilterMultiSelectText = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__vehicle_filter__multi_selected_text",
    { SELECTED_NUMBER: additionalFilters.vehicle.length },
    "",
    true,
  );

  const filterTagStrings = {
    success: {
      tagTitle: behaviourFilterTitle,
      SUCCESS: behaviourFilterSuccessOption,
      FAIL: behaviourFilterFailOption,
    },
    origin: {
      tagTitle: originFilterTitle,
    },
    destination: {
      tagTitle: destinationFilterTitle,
    },
    voyage: {
      tagTitle: voyageFilterTitle,
    },
    vehicle: {
      tagTitle: vehicleFilterTitle,
      multiSelectText: vehicleFilterMultiSelectText,
    },
  };

  const filterTags = [];

  if (additionalFilters.success.value !== "ALL") {
    const tagString = `${filterTagStrings["success"].tagTitle}: ${
      filterTagStrings["success"][additionalFilters.success.value]
    }`;
    filterTags.push({ tagString, key: "success" });
  }

  if (isAviation) {
    if (additionalFilters.origin.value !== "ALL") {
      const tagString = `${filterTagStrings["origin"].tagTitle}: ${additionalFilters.origin.value}`;
      filterTags.push({ tagString, key: "origin" });
    }

    if (additionalFilters.destination.value !== "ALL") {
      const tagString = `${filterTagStrings["destination"].tagTitle}: ${additionalFilters.destination.value}`;
      filterTags.push({ tagString, key: "destination" });
    }
  } else if (
    additionalFilters.origin.value !== "ALL" ||
    additionalFilters.destination.value !== "ALL"
  ) {
    const tagString = `${filterTagStrings["voyage"].tagTitle}: ${additionalFilters.origin.value} > ${additionalFilters.destination.value}`;
    filterTags.push({ tagString, key: "voyage" });
  }

  if (additionalFilters.vehicle) {
    if (additionalFilters.vehicle.length > 1) {
      const tagString = `${filterTagStrings["vehicle"].tagTitle}: ${filterTagStrings["vehicle"].multiSelectText}`;
      filterTags.push({ tagString, key: "vehicle" });
    } else if (additionalFilters.vehicle.length === 1) {
      const tagString = `${filterTagStrings["vehicle"].tagTitle}: ${additionalFilters.vehicle[0]}`;
      filterTags.push({ tagString, key: "vehicle" });
    }
  }

  if (filterTags.length == 0) return <></>;

  return (
    <div className="h-14 flex w-full items-center lg:order-last mb-3">
      <span className="mr-3 font-medium text-base py-2">{tagTrayText}</span>
      <div className="flex flex-wrap gap-2">
        {filterTags.map((tagInfo, index) => (
          <Tag
            key={`filterTag${index}`}
            className="py-1"
            closeFunc={() => closeFunc(tagInfo.key)}
          >
            {tagInfo.tagString}
          </Tag>
        ))}
      </div>
    </div>
  );
};

export const AdditionalFilterTagTrayControls = {};
AdditionalFilterTagTray.propTypes = AppUtils.getPropTypeFromControls(
  AdditionalFilterTagTrayControls,
);

export default AdditionalFilterTagTray;
